if (window.CKEDITOR) {
  CKEDITOR.plugins.setLang('nbsp', 'fr', {
    label: 'Ajouter une espace insécable',
  });
}
